import { useQueryClient } from "@tanstack/react-query";
import { CcofPatientDetails } from "lib/api-types/schemas";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { deepMerge, DeepPartial } from "@/lib/object";
import { patientDetailsQueryKey } from "../queries/usePatientDetails";
import { useCallback } from "react";

export function useUpdatePatientDetailsCache(patientId: string) {
  const queryClient = useQueryClient();
  const { tenantId } = useTenantRouteContext();

  return useCallback(
    (patch: DeepPartial<CcofPatientDetails>) => {
      queryClient.setQueryData<CcofPatientDetails>(
        patientDetailsQueryKey(tenantId, patientId),
        (prev) => {
          if (!prev) return prev;
          return deepMerge<CcofPatientDetails>(prev, patch);
        },
      );
    },
    [patientId, tenantId, queryClient],
  );
}
